import { makeGroup, makeHull, makeCurve } from 'mint-turn';
import randomColor from 'randomcolor';
import Vec3 from 'gl-vec3';

const makePlatform = (center, bounds) => {
  const [x, y, z] = center;
  const [xp, yp, zp] = Vec3.add([], center, bounds);
  const [xm, ym, zm] = Vec3.subtract([], center, bounds);
  const triangles = [
    [[xm,yp,zm],[xp,yp,zp],[xp,yp,zm]],
    [[xm,yp,zm],[xm,yp,zp],[xp,yp,zp]],
    
    [[xp,ym,zm],[xm,ym,zm],[xp,yp,zm]],
    [[xm,ym,zm],[xm,yp,zm],[xp,yp,zm]],
    
    [[xp,ym,zp],[xp,yp,zp],[xm,ym,zp]],
    [[xm,ym,zp],[xp,yp,zp],[xm,yp,zp]],
    
    [[xp,ym,zp],[xm,yp,zp],[xm,ym,zm]],
    [[xm,ym,zm],[xm,yp,zp],[xm,yp,zm]],
    
    [[xp,ym,zp],[xp,ym,zm],[xp,yp,zp]],
    [[xp,ym,zm],[xp,yp,zm],[xp,yp,zp]],
  ];
  const smooth = 0.2;
  const hull = makeHull([[xm,ym,zm], [xm,ym,zp], [xp,ym,zm], [xp,ym,zp], [xm,yp,zm], [xm,yp,zp], [xp,yp,zm], [xp,yp,zp]], smooth);
  hull[0].setAttribute('fill', randomColor());
  const top = makeCurve([[xm,yp,zm], [xp,yp,zm], [xp,yp,zp], [xm,yp,zp]], true, smooth);
  top[0].setAttribute('fill', 'hsla(0, 50%, 100%, 40%)');
  top[0].setAttribute('stroke', 'none');
  const bottom = makeCurve([[xm,ym,zm], [xp,ym,zm], [xp,ym,zp], [xm,ym,zp]], true, smooth);
  bottom[0].setAttribute('fill', 'hsla(0, 50%, 0%, 10%)');
  bottom[0].setAttribute('stroke', 'none');
  const fill = makeGroup(center, [bottom, hull, top]);
  const outline = makeHull([[xm,ym,zm], [xm,ym,zp], [xp,ym,zm], [xp,ym,zp], [xm,yp,zm], [xm,yp,zp], [xp,yp,zm], [xp,yp,zp]], smooth);
  outline[0].setAttribute('stroke', 'black');
  outline[0].setAttribute('stroke-width', 5);
  outline[0].setAttribute('fill', 'none');
  const svg = makeGroup(center, [fill, outline]);
  return [triangles, svg];
};

export default makePlatform;